import { deepEqualObjects } from './object-utils';

export function sampleSize(array: any[], n: number) {
  n = n == null ? 1 : n;
  const length = array == null ? 0 : array.length;
  if (!length || n < 1) {
    return [];
  }
  n = n > length ? length : n;
  let index = -1;
  const lastIndex = length - 1;
  const result = [...array];
  while (++index < n) {
    const rand = index + Math.floor(Math.random() * (lastIndex - index + 1));
    const value = result[rand];
    result[rand] = result[index];
    result[index] = value;
  }
  return result.slice(0, n);
}

export function countOfDeepEqualObjects(obj: any, arr: Array<any>): number {
  return arr.reduce((acc, curr) => {
    if (deepEqualObjects(obj, curr)) {
      acc++;
    }
    return acc;
  }, 0);
}

export function indexOfFirstOccurrence(
  obj: any,
  arr: Array<any>,
): number | undefined {
  for (let index = 0; index < arr.length; index++) {
    if (deepEqualObjects(arr[index], obj)) {
      return index;
    }
  }
  return undefined;
}
